"use strict";

import angular from "angular";

import template from "./empty-contract-accounting.component.html";
import "./themes/empty-contract-accounting.component.scss";
import "./themes/empty-contract-accounting.component-dark.scss";

import { AssistantHttpGateway } from "../../../gateway/AssistantHttpGateway";
import { UserDataAdapter } from "../../../presentation/adpters/UserDataAdapter";
import _ from "lodash";
import { registerCustomerRequest } from "../../../presentation/services/CustomerRequest/register-customer-request";
import { Events } from "../../../presentation/services/Events/Events";
import { EmailSESService } from "../../../presentation/services/EmailSES/EmailSES";
import requestContractDialogTemplate from "../../dialogs/request-contract/request-contract-dialog.html";
import { requesterFromUser } from "../../email/internal-email-layout";
import { TemplateFeatureRequest } from "./template-feature-request";

export class EmptyContractAccountingComponent {
    Events = new Events();
    AssistantHttpGateway = new AssistantHttpGateway();

    constructor(DSNDialogService) {
        this.DSNDialogService = DSNDialogService;
    }

    $onInit() {
        this.user = new UserDataAdapter().user();

        this.isAdmin = this.user.roles.includes("Contabilidade");

        this.buttonProps = !this.isAdmin
            ? false
            : { label: "Solicitar contato", icon: "fas fa-rocket" };
    }

    // Sem a trava de produção do e-mail: o kanban do sandbox também existe, e é lá que o
    // registro é testado. Fire-and-forget, nunca rejeita (ver registerCustomerRequest).
    registerRequest() {
        return registerCustomerRequest(this.AssistantHttpGateway, {
            tipo: "feature",
            accountingId: _.get(this.accountingData, "_id"),
            detalhes: { feature: this.feature }
        });
    }

    sendEmail() {
        if (publicSettings.environment != "production") return;

        const templateString = this.templateEmail({
            plan: this.accountingData.contract,
            hubspotId: _.get(this.accountingData, "hubspot._id"),
            accountingCode: _.get(this.accountingData, "superLogica._id"),
            feature: this.feature,
            requester: requesterFromUser(this.user)
        });

        const senderEmail = new EmailSESService();

        const subject = `Solicitação de Feature: ${this.accountingData.name}`;

        senderEmail.sendBulk({
            subject: subject,
            to: [
                { name: "Hadna Esteves", email: "hadna.esteves@nucont.com" },
                {
                    name: "Giovanni Gontijo",
                    email: "giovanni.gontijo@nucont.com"
                },
                {
                    name: "Matheus Queiroga",
                    email: "matheus.queiroga@nucont.com"
                },
                {
                    name: "Fernando Pinheiro",
                    email: "fernando.pinheiro@nucont.com"
                },
                { name: "Thaina Souza", email: "thaina.souza@nucont.com" },
                { name: "Vinicius", email: "vinicius@nucont.com" }
            ],
            from: {
                name: "Nucont",
                email: "nanda@nucont.com"
            },
            bodyOptions: {
                reference: "ComunicacaoInterna",
                defaultParams: {
                    subject: subject,
                    templateString
                }
            }
        });
    }

    requestContract($event) {
        this.Events.send(`Solicitacao.Feature.${this.feature}`);

        this.sendEmail();
        this.registerRequest();

        this.DSNDialogService.custom({
            targetEvent: $event,
            controller: "RequestContractDialogCtrl",
            controllerAs: "$ctrl",
            clickOutsideToClose: true,
            locals: {
                width: "450px",
                templateHtml: requestContractDialogTemplate
            },
            after: {}
        });
    }

    templateEmail({ plan, hubspotId, accountingCode, feature, requester }) {
        return TemplateFeatureRequest({
            accounting: {
                name: this.accountingData.name,
                superLogicaId: accountingCode,
                hubspotId,
                contract: plan,
                integrationsHealth: this.accountingData.integrationsHealth
            },
            feature,
            requester
        });
    }
}

EmptyContractAccountingComponent.$inject = ["DSNDialogService"];

const name = "emptyContractAccountingComponent";
const def = {
    controller: EmptyContractAccountingComponent,
    bindings: {
        isContract: "@",
        description: "@",
        feature: "@",
        accountingData: "<"
    },
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
